import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';
import { FsTransferService } from '@firestitch/transfer';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ObjectData {

  constructor(
    private _api: FsApi,
    private _transfer: FsTransferService,
  ) { }

  public get(objectId, query = {}): Observable<any> {
    return this._api.get(`objects/${objectId}`, query, { key: 'object' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'objects', data, { key: 'objects', ...config });
  }

  public image(objectId, type, file): Observable<any> {
    return this._api.put(`objects/${objectId}/image`, { file, type }, { key: 'objectImage' });
  }

  public filesPost(objectId: number, data): Observable<any> {
    return this._api.post(`objects/${objectId}/files`, data, { key: 'file' });
  }

  public filesDelete(objectId: number, file: any): Observable<any> {
    return this._api.delete(`objects/${objectId}/files/${file.id}`, {}, { key: 'file' });
  }

  public filesDownload(objectId, file): void {
    this._transfer.post(`objects/${objectId}/files/${file.id}/download`);
  }

  public filesGets(objectId: number, data: any, config: {}): Observable<any> {
    return this._api.get(`objects/${objectId}/files`, data, { key: 'files', ...config });
  }

  public configsGets(objectId: number, names: string[] = []): Observable<any> {
    return this._api.get(`objects/${objectId}/configs`, { names }, { key: 'configs' });
  }

  public configsPost(objectId: number, configs: any): Observable<any> {
    return this._api.post(`objects/${objectId}/configs`, { configs }, { key: 'configs' });
  }

  public typesPut(objectId: number, data: any): Observable<any> {
    return this._api.put(`objects/${objectId}/types`, data, { key: 'types' });
  }

}
